import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, Signal, viewChild } from '@angular/core';
import { LogService } from '../../../debug/services/log.service';
import { WindowSizeService } from '../../../../services/window-size.service';
import { toSignal } from '@angular/core/rxjs-interop';

/**
 * Maximum width of the donation meter
 */
const MAX_WIDTH = 180;

@Component({
    selector: 'app-donation-meter',
    imports: [],
    templateUrl: './donation-meter.component.html',
    styleUrl: './donation-meter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonationMeterComponent {
  /**
   * DI
   */
  private readonly logService = inject(LogService);
  private readonly windowSizeService = inject(WindowSizeService);

  /**
   * 
   */
  donationMeterContainer: Signal<ElementRef | undefined> = viewChild('donationMeterContainer');
  /**
   * Required input for the target amount of donations.
   * - e.g. '100'
   */
  target = input.required();

  /**
   * Required input for the current amount of donations.
   * - e.g. '50'
   */
  current = input.required();

  /**
   * Optional input for the height of the graphics
   */
  height = input('200');

  /**
   * Window width
   */
  windowWidth = toSignal(this.windowSizeService.width$);
  /**
   * Writeable signal used in HTML template and impacting the presentation.
   */
  model = computed(() => {
    const windowWidth = this.windowWidth();
    const target = Number(this.target());
    const current = Number(this.current());
    //const height = Number(this.height());
    //const width = height * 1.503731343283582;
    const width = (this.donationMeterContainer()?.nativeElement.offsetWidth || 0) > MAX_WIDTH ? MAX_WIDTH : (this.donationMeterContainer()?.nativeElement.offsetWidth || 0);
    const height = width / 1.503731343283582;

    const percentFulfilled = Math.floor((current / target) * 100);
    const barHeight = percentFulfilled * 3.85; // *(height / 100);
    const flagHeightHidden = 462 - barHeight;

    this.logService.log('DonationMeterComponent, windowWidth', windowWidth);
    this.logService.log('DonationMeterComponent, target', target);
    this.logService.log('DonationMeterComponent, current', current);
    this.logService.log('DonationMeterComponent, width', width);
    this.logService.log('DonationMeterComponent, height', height);
    this.logService.log('DonationMeterComponent, percentFulfilled', percentFulfilled);
    this.logService.log('DonationMeterComponent, barHeight', barHeight);
    this.logService.log('DonationMeterComponent, flagHeightHidden', flagHeightHidden);

    return {
      flagHeightHidden,
      percentFulfilled,
      percentFulfilledText: `${percentFulfilled}%`,
      barHeight,
      textAlignment: percentFulfilled === 0 ? 15 : percentFulfilled === 100 ? 5 : 7,
      svgWidth: `${width}px`,
      svgHeight: `${height}px`
    };
  })

  }


